import getConversationSortByProperty from '../../../utils/tables/getConversationSortByProperty';
import onLoadInitialRowsSucceeded from '../onLoadInitialRowsSucceeded';
import { action } from 'satcheljs/lib/legacy';
import { findConversationWithStartIndex } from 'owa-mail-store';
import { getBaseFolderId } from 'owa-mail-list-store';
import { getMailboxInfoFromTableQuery } from 'owa-mail-mailboxinfo';
import { INITIAL_LOAD_ROW_COUNT } from '../../data-loading/TableLoadingConstants';
import { PerformanceDatapoint } from 'owa-analytics';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
/**
 * Load the initial conversations from the server
 * @param tableView to load conversations in
 * @param OnInitialTableLoadComplete is a callback that is called when we receive the response
 * The callback is handled by table loading
 * @param isTablePrefetched indicates if the table is prefetched
 * @return a promise that resolves when the load table from server has completed
 */
export default action('loadInitialConversationsFromServer')(function loadInitialConversationsFromServer(tableView, isTablePrefetched, onInitialTableLoadComplete) {
    var mailTableQuery = tableView.tableQuery;
    var findConversationDatapoint = new PerformanceDatapoint('TnS_FindConversation');
    findConversationDatapoint.addCustomProperty('scenarioType', mailTableQuery.scenarioType);
    findConversationDatapoint.addCustomProperty('isPrefetch', isTablePrefetched);
    findConversationDatapoint.addCustomProperty('isFilter', mailTableQuery.viewFilter && mailTableQuery.viewFilter !== 'All');
    findConversationDatapoint.addCustomProperty('isSort', mailTableQuery.sortBy &&
        (mailTableQuery.sortBy.sortColumn !== 0 /* Date */ ||
            mailTableQuery.sortBy.sortDirection !== 'Descending'));
    // https://msfast.visualstudio.com/FAST/_workitems/edit/260700: Remove this line once flight is 100% WW
    findConversationDatapoint.addCustomProperty('isRoamingFavoritesEnabled', isControlFeatureEnabled('tri-favorites-roaming'));
    return findConversationWithStartIndex(getBaseFolderId(mailTableQuery), 0 /* startIndex */, INITIAL_LOAD_ROW_COUNT, mailTableQuery.viewFilter, getConversationSortByProperty(mailTableQuery), mailTableQuery.focusedViewFilter, mailTableQuery.requestShapeName, mailTableQuery.shouldTryToUseSessionDataResponse, getMailboxInfoFromTableQuery(mailTableQuery).requestOptions, mailTableQuery.categoryName).then(function (response) {
        var promiseToReturn = Promise.resolve();
        var responseMessage = response.findConversationResponseMessage;
        // Flag indicating whether we're already showing cached results on the table before the refresh of top rows
        var tableHasCachedItems = tableView.rowKeys.length > 0;
        var isSuccessResponseClass = responseMessage.ResponseClass == 'Success';
        if (isSuccessResponseClass) {
            // Explicitly logging request-id here. In case of error, it will be automatically logged
            // as part of findConversationDatapoint.endWithError()
            findConversationDatapoint.addCustomProperty('request-id', response.responseInit.headers.get('request-id'));
            findConversationDatapoint.end();
            onLoadInitialRowsSucceeded(tableView, responseMessage.Conversations, responseMessage.TotalConversationsInView, responseMessage.SearchFolderId, responseMessage.FolderId);
        }
        else {
            var error = new Error("ResponseCode=" + responseMessage.ResponseCode + ", Stacktrace=" + responseMessage.StackTrace);
            error.fetchErrorType = 'ServerFailure';
            error.response = new Response(undefined, response.responseInit);
            findConversationDatapoint.endWithError("ServerError" /* ServerError */, error);
            promiseToReturn = Promise.reject(error);
        }
        onInitialTableLoadComplete(tableView, isSuccessResponseClass, responseMessage.ResponseCode, isTablePrefetched, tableHasCachedItems);
        return promiseToReturn;
    }, function (error) {
        // Server returned non-200 response
        findConversationDatapoint.endWithError("ServerError" /* ServerError */, error);
        var responseCode = (error && error.response && error.response.status) || '';
        onInitialTableLoadComplete(tableView, false, responseCode, isTablePrefetched, tableView.rowKeys.length > 0);
        return Promise.reject(error);
    });
});
//# sourceMappingURL=loadInitialConversationsFromServer.js.map